import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import { memo } from "react";

/**
 * 說明：
 * - 配置 sanitizeConfig 來允許特定的 HTML 標籤和屬性
 * - 提供多層次的安全防護機制
 * 
 * 安全防護機制：
 * - 標籤白名單：只允許安全的 HTML 標籤
 * - 屬性控制：限制每個標籤的允許屬性
 * - 協議限制：只允許安全的 URL 協議（http, https, mailto, tel）
 * - DOM 保護：使用 clobberPrefix 防止 ID 注入攻擊
 * - 註解阻擋：禁用 HTML 註解防止隱藏惡意內容
 * - 內容保留：未知內容轉換為純文字而非強制移除
 */
const sanitizeConfig = {
  tagNames: [
    'a', 'img', 'p', 'div', 'span',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'strong', 'em', 'code', 'pre', 'blockquote', 'br',
    'iframe' // 僅允許特定來源
  ],
  attributes: {
    a: ['href', 'title', 'target', 'rel'],
    img: ['src', 'alt', 'title', 'width', 'height'],
    iframe: ['src', 'width', 'height', 'title', 'allowfullscreen', 'frameborder'],
    '*': ['id', 'className']
  },
  protocols: {
    href: ['http', 'https', 'mailto', 'tel'],
    src: ['http', 'https'] // 避免 javascript: 或 data: 攻擊
  },
  clobberPrefix: 'user-content-', // 避免 id 注入干擾 DOM
  allowComments: false,           // 阻擋 HTML 註解
  strip: false                    // 保留未知內容作為純文字（false 表示不強制移除）
};

const SafeMarkdownRenderer = memo(({ content }) => {
  return (
    <span className="markdown-body">
      <ReactMarkdown
        children={content}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeConfig]]}
         components={{
          a: props => (
          <a {...props} 
              target="_blank"/>
          ),
      }}
      />
    </span>
  );
});

export default SafeMarkdownRenderer;
